(() => {
  const shopify = window.Shopify || {};
  if (shopify.designMode) return;

  const supportedCountries = new Set(['CA', 'CO', 'US', 'MX']);
  const root = shopify.routes?.root || '/';
  const currentCountry = String(shopify.country || '').toUpperCase();
  const currentLanguage = String(shopify.language || document.documentElement.lang || 'en')
    .split('-')[0]
    .toLowerCase();
  const guardKey = 'goalstyle:auto-market:v1';
  const manualCountryKey = 'goalstyle:manual-country:v1';

  // The footer form submits immediately; capture the choice before its inline handler runs.
  document.addEventListener('change', (event) => {
    const select = event.target;
    if (select instanceof HTMLSelectElement && select.matches('#GoalStyleFooterCountry select[name="country_code"]')) {
      try {
        localStorage.setItem(manualCountryKey, String(select.value || '').toUpperCase());
      } catch (_) {}
    }
  }, true);

  let manualCountry = '';
  try {
    manualCountry = String(localStorage.getItem(manualCountryKey) || '').toUpperCase();
  } catch (_) {}

  const applyCountry = (country) => {
    try {
      sessionStorage.setItem(guardKey, country);
    } catch (_) {}

    const form = document.createElement('form');
    form.method = 'POST';
    form.action = `${root}localization`;
    form.hidden = true;

    const fields = {
      _method: 'PUT',
      country_code: country,
      language_code: currentLanguage,
      return_to: `${window.location.pathname}${window.location.search}`
    };

    Object.entries(fields).forEach(([name, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  };

  if (manualCountry) {
    if (manualCountry !== currentCountry) applyCountry(manualCountry);
    return;
  }

  try {
    if (sessionStorage.getItem(guardKey) === currentCountry && currentCountry) return;
  } catch (_) {}

  const params = new URLSearchParams();
  params.set('country[enabled]', 'true');
  params.set('language[enabled]', 'false');
  if (currentCountry) params.set('country[exclude]', currentCountry);

  const suggestionsUrl = `${root}browsing_context_suggestions.json?${params.toString()}`;

  fetch(suggestionsUrl, {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' }
  })
    .then((response) => (response.ok ? response.json() : null))
    .then((data) => {
      if (!data) return;

      const detectedCountry = String(data?.detected_values?.country?.handle || '').toUpperCase();
      const suggestedCountry = String(
        data?.suggestions?.find((suggestion) => {
          const code = String(suggestion?.parts?.country?.handle || '').toUpperCase();
          return supportedCountries.has(code);
        })?.parts?.country?.handle || ''
      ).toUpperCase();

      const targetCountry = supportedCountries.has(detectedCountry)
        ? detectedCountry
        : suggestedCountry;

      if (!targetCountry || targetCountry === currentCountry) {
        try {
          if (currentCountry) sessionStorage.setItem(guardKey, currentCountry);
        } catch (_) {}
        return;
      }

      applyCountry(targetCountry);
    })
    .catch(() => {
      /* Keep Shopify's current market when geolocation is unavailable. */
    });
})();
